import React, { Fragment, useEffect, useState } from "react";
import ReactTable from "react-table";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  IconButton,
  Box,
} from "@mui/material";

import {
  addGroup,
  fetchGroups,
  addGroupToMonitorItem,
  fetchMonitoredItem,
  removeGroupFromMonitoredSearchHistory,
} from "./api";

import AddGroupRodal, { EVENTS as AddGroupRodalEvents } from "../AddGroupRodal";

export const EVENTS = {
  CANCEL: ["CANCEL", ""],
};

const MonitoredItemGroupModal = (props) => {
  const isOpen = props.isOpen || false;
  const selectedItem = props.selectedItem || {};
  const onModalEvent = props.onModalEvent;
  const BaseHeader = props.baseHeader || (() => <></>);
  const page = props.page;

  const [monitoredItem, setMonitoredItem] = useState({});
  const [groupList, setGroupList] = useState([]);

  const [addRodalIsOpen, setAddRodalIsOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    reFetch();
  }, [isOpen]);

  const reFetch = async () => {
    fetchMonitoredItem(selectedItem.id)
      .then((response) => {
        setMonitoredItem(response.data);
      })
      .catch(console.error);
    fetchGroups(selectedItem.id)
      .then((response) => {
        setGroupList(response.data);
      })
      .catch(console.error);
  };

  const removeGroupFromMonitoredItem = async (groupId) => {
    await removeGroupFromMonitoredSearchHistory(monitoredItem.id, groupId);
    await reFetch();
  };

  const addGroupAction = async (groupId) => {
    await addGroupToMonitorItem(monitoredItem.id, groupId);

    await reFetch();
  };

  const emit = (event) => {
    return () => {
      onModalEvent(...event);
    };
  };

  return (
    <Fragment>
      <AddGroupRodal
        isOpen={addRodalIsOpen}
        emitAction={(e, data) => {
          if (e === AddGroupRodalEvents.CANCEL) {
            setAddRodalIsOpen(false);
          }

          if (e === AddGroupRodalEvents.ADD) {
            addGroup(data.name).then((response) => {
              const responseData = response.data;

              setAddRodalIsOpen(false);
              addGroupAction(responseData.data.id);
            });
          }
        }}
      />

      <Modal isOpen={isOpen}>
        <div
          style={{
            marginTop: "10px",
            display: "flex",
            justifyContent: "space-between",
            width: "inherit",
          }}
        >
          <BaseHeader page={page} style={{marginLeft: "10px"}} />
          <Button
            style={{marginLeft: "5px"}}
            className="mb-2 mr-2 btn-icon btn-icon-only btn-dashed"
            outline
            color="success"
            onClick={emit(EVENTS.CANCEL)}
          >
            <i className="pe-7s-check btn-icon-wrapper"> </i>
          </Button>
        </div>
        <ModalHeader>
          <p> Assign groups to monitored item </p>
        </ModalHeader>

        <ModalBody>
          <List dense>
            {monitoredItem && monitoredItem.groups ? (
              monitoredItem.groups.map((group) => (
                <ListItem
                  key={group.id}
                  secondaryAction={
                    <IconButton
                      edge="end"
                      aria-label="delete"
                      onClick={() => {
                        removeGroupFromMonitoredItem(group.id);
                      }}
                    >
                      <i className="pe-7s-trash" />
                    </IconButton>
                  }
                >
                  <ListItemIcon>
                    <i className="pe-7s-notebook" />
                  </ListItemIcon>
                  <ListItemText primary={group.name} />
                </ListItem>
              ))
            ) : (
              <></>
            )}
          </List>
          <Button
            style={{ marginLeft: "18px" }}
            onClick={() => {
              setAddRodalIsOpen(true);
            }}
          >
            {" "}
            Add new group{" "}
          </Button>
          <Box sx={{ m: 2 }}>
            <ReactTable
              data={groupList || []}
              columns={[
                { Header: "Group", accessor: "name" },
                {
                  Header: "Action",
                  maxWidth: 80,
                  Cell: (cellInfo) => {
                    return (
                      <Button
                        className="mb-2 mr-2 btn-icon btn-icon-only"
                        onClick={() => {
                          addGroupAction(cellInfo.original.id);
                        }}
                        outline
                        color="success"
                      >
                        <i className="pe-7s-plus btn-icon-wrapper">{""}</i>
                      </Button>
                    );
                  },
                },
              ]}
              minRows={5}
            />
          </Box>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default MonitoredItemGroupModal;
